/**
 * The cookie banner's answer, kept per site: the key is the site id.
 *
 * ADR-183: the banner text now also says the site keeps which ad or link
 * brought the visitor. A visitor who clicked OK on the old text agreed to
 * less, so the stored answer carries a version, and the old "true" no longer
 * counts: the banner shows once more, with the new text.
 */
const CONSENT_VALUE = "2"

export function hasCookieConsent() {
  try {
    return Boolean(process.env.SITE_ID) && window.localStorage.getItem(process.env.SITE_ID) === CONSENT_VALUE
  } catch (err) {
    return false
  }
}

export function giveCookieConsent() {
  try {
    window.localStorage.setItem(process.env.SITE_ID, CONSENT_VALUE)
  } catch (err) {
    // Storage blocked: the banner will ask again next time.
  }
}
